import React, { useState } from "react";
import MonStyle from "./CheckoutForm.module.css";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import BoutonActionPrincipale from "../../../../Design/Boutons/BoutonActionPrincipale";
import MessageErreur from "../../../../Design/Messages/MessageErreur";

const CheckoutFormPaiement = () => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [error, setError] = useState();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: window.location.origin + "/facturation/carte-bancaire",
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      console.log({ error });
      setErrorMessage(error.message);

      if (!error.code) {
        setError(error);
      }
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <div className={MonStyle.CheckoutForm}>
      <form onSubmit={handleSubmit} className={MonStyle.Form}>
        <PaymentElement />
        <MessageErreur
          message={errorMessage}
          error={error}
          style={{ marginTop: "30px" }}
        />
        <BoutonActionPrincipale
          texte="Payer (confirmPayment)"
          taille="L"
          fullWidth
          style={{ margin: "30px 0px" }}
        />
      </form>
    </div>
  );
};

export default CheckoutFormPaiement;
